import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords = [],
  image,
  url,
  type = 'website',
  product = null,
}) => {
  const siteTitle = 'IT World - Software Licenses Store';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const baseUrl = window.location.origin;
  const fullUrl = url ? `${baseUrl}${url}` : window.location.href;
  const defaultImage = `${baseUrl}/logo.png`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      {description && <meta name="description" content={description} />}
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(', ')} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:site_name" content={siteTitle} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      {description && <meta property="twitter:description" content={description} />}
      <meta property="twitter:image" content={image || defaultImage} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="IT World" />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Product Specific Meta Tags */}
      {product && (
        <>
          <meta property="og:type" content="product" />
          <meta property="product:price:amount" content={product.basePrice} />
          <meta property="product:price:currency" content="INR" />
          {product.stockCount > 0 && <meta property="product:availability" content="in stock" />}
          {product.category && <meta property="product:category" content={product.category} />}
        </>
      )}
    </Helmet>
  );
};

export default SEO;
